import React, { forwardRef } from "react";
import { Textarea as RebassTextarea } from "@rebass/forms/styled-components";
import styled from "styled-components";
import theme from "../../../theme/themeThree";

let StyledTextarea = styled(RebassTextarea)((props) => {
  return props.error
    ? {
        borderColor: theme.colors.error,
        ":hover": {
          borderColor: theme.colors.error,
        },
        ":active": {
          borderColor: theme.colors.error,
        },
        ":focus": {
          borderColor: theme.colors.error,
        },
      }
    : {};
});

const Textarea = forwardRef((props, ref) => {
  return (
    <StyledTextarea
      sx={{
        ...theme.input,
        ...theme.variants.textarea.default,
      }}
      ref={ref}
      {...props}
    />
  );
});

export { Textarea };
